import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { twMerge } from 'tailwind-merge'
import {
  CustomLinkComponent,
  DynamicTag,
  PageActionPlaceHolder,
  Spinner
} from 'msp-components'
import { useAccount } from 'msp-integrations'

import AccountOverviewOrderDetails from './AccountOverviewOrderDetails/AccountOverviewOrderDetails'

import translations from './AccountOverviewOrders.constants'
import * as S from './AccountOverviewOrders.styles'

export type AccountOverviewOrdersProps = {
  maxOrdersToDisplay?: number
  className?: string
}

const MAX_ORDERS_TO_DISPLAY = 3

const AccountOverviewOrders = ({
  maxOrdersToDisplay = MAX_ORDERS_TO_DISPLAY,
  className = ''
}: AccountOverviewOrdersProps) => {
  const { formatMessage } = useIntl()
  const {
    orders: { isLoading, orders, hasOrders, fetchOrders }
  } = useAccount()
  const pageLink = '/account/orders'

  useEffect(() => {
    if (!hasOrders) {
      fetchOrders()
    }
  }, [])

  return (
    <div className={twMerge(S.MainWrapper, className)}>
      <DynamicTag
        componentTagName='Headline'
        tag='h2'
        tagStyle='h6'
        className={S.Headline}
      >
        {formatMessage(translations.headline)}
      </DynamicTag>
      {isLoading && <Spinner />}
      {!isLoading && hasOrders && (
        <>
          <div className={S.ListWrapper}>
            {orders.slice(0, maxOrdersToDisplay).map((order) => (
              <AccountOverviewOrderDetails
                key={`order-${order.orderNo}`}
                order={order}
              />
            ))}
          </div>
        </>
      )}
      {!isLoading && !hasOrders && (
        <div className={S.ListWrapper}>
          <PageActionPlaceHolder text={formatMessage(translations.noOrders)} />
        </div>
      )}
      {hasOrders && (
        <CustomLinkComponent href={pageLink} className={S.Link}>
          {formatMessage(translations.headline)}
        </CustomLinkComponent>
      )}
    </div>
  )
}

export default AccountOverviewOrders
